<span [class]="loading ? 'btn-disable-text' : class" (click)="onTextClick($event)">
  <ng-content></ng-content>
</span>
